$(document).ready(function () {
  $('#add-budget-option').click(function (e) {
    e.preventDefault()

    const rawAmount = $('#budget-amount').val()
    const amount = removeCommas(rawAmount)

    if (allWhiteSpaces(amount) || isNaN(amount)) {
      toastNotification('error', 'amount is not a proper number')

      return
    }

    const codeId = $('#budget-item-code-id option:selected').val()
    const itemType = $('#budget-item-type').val()
    const state = $('#budget-state').val()
    const budgetId = $('#budget-id').val()
    const redirectUrl = `/budgets/${budgetId}/?item_type=${itemType}`

    $.ajax({
      type: 'POST',
      url: '/save_budget_item',
      headers: {
        'X-CSRF-Token': csrfToken()
      },
      data: {
        code_id: codeId, amount: amount,
        item_type: itemType, state: state, budget_id: budgetId
      },
      dataType: "json",
      success: function (data) {
        if (data.success == true) {
          toastNotification('success', data.message);
          window.location.reload(redirectUrl);
        } else {
          toastNotification('error', data.message);
        }

        console.log(data);
      },
      error: function (data) {
        console.log('An error occurred.');
        console.log(data);
      },
    });

  });
});
